import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Modal, Form, Breadcrumb, Table } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { DeleteChallenge, GetChallenges, GetStudentDetail, handleDownload, GetAllStudentDetail } from '../../utils/axios/ChallengesAPI';
import { GrokLoading } from '../page-layout/loading/Loading';
import { ConfirmAlert, TimerAlert, InforAlert } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import moment from "moment";
import { Margin, usePDF } from "react-to-pdf";
import { GetMyChallengesById, handlePdfDownloadStudentChallenge, handleVideoDownloadStudentChallenge } from '../../utils/axios/MyChallengesAPI';
import { GetApproval } from '../../utils/axios/ChallengeWinnerAPI';
import '../page-layout/newCertificate/Certificate_gcc.css';
import { GetNotificationCertificate } from "../../utils/axios/NotificationAPI";
import { ROLE } from "../constants/constants";

const Challenges = () => {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState('');
    const [studentData, setStudentData] = useState('');

    const [name, setName] = useState('');
    const [collegeName, setCollegeName] = useState('');
    const [challengeName, setChallengeName] = useState('');
    const [registeredDate, setRegisteredDate] = useState('');
    const [year, setYear] = useState('');
    const [semester, setSemester] = useState('');
    const [branch, setBranch] = useState('');
    const [submittedDate, setSubmittedDate] = useState('');
    const [availableComponents, setAvailableComponents] = useState('');
    const [additionalComponents, setAdditionalComponents] = useState('');
    const [circuitDiagram, setCircuitDiagram] = useState('');
    const [pythonCode, setPythonCode] = useState('');
    const [projectBrief, setProjectBrief] = useState("");
    const [solution, setSolution] = useState('');
    const [feedBack, setFeedback] = useState('');
    const [filteredData, setFilteredData] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [isPreview, setIsPreview] = useState(false);
    const [certificateId, setCertificateId] = useState("");
    const handleShow = (title, description) => {
        setShow(true);

        setTimeout(() => {
            document.getElementById('Title').innerText = title;
            document.getElementById('Description').innerText = description
        }, 10);
    }

    const StudentTable = useRef();
    const ref = React.createRef();

    // Participation certificate modal
    const [participationcertShow, setParticipationCertShow] = useState(false);
    const handleParticipationCertClose = () => setParticipationCertShow(false);
    const handleParticipationCertShow = (id) => {
        setParticipationCertShow(true);
        getNotificationCertificate(id);
    }

    // Participation Certificate Get method
    const [CertificateData, setCertificateData] = useState('');

    const getNotificationCertificate = async (challengeId) => {
        let notificationCertificatePayload = {
            StudentChallengeId: challengeId
        }
        setLoading(true);
        let notificationCertificateResponse = await GetNotificationCertificate(notificationCertificatePayload);
        setCertificateData(notificationCertificateResponse.studentChallenge);
        setCertificateId(notificationCertificateResponse.studentChallenge.CertificateId);
        setLoading(false);
    }

    // Project report modal 
    const [myChallengeShow, setMyChallengeShow] = useState(false);
    const handleMyChallengesClose = () => {
        setMyChallengeShow(false);
        setName('');
        setCollegeName('');
        setChallengeName('');
        setRegisteredDate('');
        setSubmittedDate('');
        setAvailableComponents('');
        setAdditionalComponents('');
        setCircuitDiagram('');
        setPythonCode('');
        setProjectBrief('');
        setSolution('');
        setFeedback('');
    }
    const handleMyChallengesShow = async (id) => {
        setMyChallengeShow(true);
        setLoading(true);
        var myChallengesResponse = await GetMyChallengesById(id);
        setName(myChallengesResponse.data[0].StudentId.DisplayName);
        setCollegeName(myChallengesResponse.data[0].OrganizationId.name);
        setChallengeName(myChallengesResponse.data[0].ChallengeId.name);
        setRegisteredDate(moment(myChallengesResponse.data[0].CreatedDate).format('DD/MM/YYYY'));
        setCollegeName(myChallengesResponse.data[0].StudentId.OrganizationId.name)
        setYear(myChallengesResponse.data[0].StudentId.Year.name);
        setBranch(myChallengesResponse.data[0].StudentId.Branch.name);
        setSemester(myChallengesResponse.data[0].StudentId.Semester.name);
        setSubmittedDate(moment(myChallengesResponse.data[0].SubmissionDate).format('DD/MM/YYYY'));
        setAvailableComponents(myChallengesResponse.data[0].AvailableComponents);
        setAdditionalComponents(myChallengesResponse.data[0].AdditionalComponents);
        setSolution(myChallengesResponse.data[0].Solution);
        setPythonCode(myChallengesResponse.data[0].PythonCode);
        setCircuitDiagram(myChallengesResponse.data[0].CircuitDiagram);
        setProjectBrief(myChallengesResponse.data[0].ProjectBrief);
        setFeedback(myChallengesResponse.data[0].Feedback);
        setLoading(false);
    };
    const filterRef = useRef();
    const { toPDF, targetRef } = usePDF({
        filename: (`${name}-${challengeName}`),
        page: { margin: Margin.MEDIUM }
    });

    const [dataDetail, setDataDetail] = useState([]);
    const [showParticipants, setShowParticipants] = useState(false);
    const handleCloseParticipants = () => setShowParticipants(false);

    // challenge participants modal, view solution and generate certificate
    const handleShowParticipants = async (id, title, orgName) => {
        let studentDetailResponse;
        let studentDetailPayload = {};
        if (userInfo.RoleId === ROLE.COLLEGE) {
            studentDetailPayload = {
                ChallengeId: id,
                OrganizationId: userInfo.OrganizationId
            };
            setLoading(true);
            studentDetailResponse = await GetStudentDetail(studentDetailPayload);
            setLoading(false);
        } else {
            studentDetailPayload = {
                ChallengeId: id
            };
            setLoading(true);
            studentDetailResponse = await GetAllStudentDetail(studentDetailPayload);
            setLoading(false);
        }
        setShowParticipants(true);
        if (studentDetailResponse.success) {
            const tableRows = [];

            studentDetailResponse.data.forEach((org) => {
                const clg = org.organization;
                const students = org.students;
                tableRows.push(`<tr><td class='text-nowrap' rowspan="${students.length + 1}">${clg.name}</td></tr>`);
                students.forEach((student) => {
                    let certificateButton = '';
                    let previewCertificateButton = '';
                    let certificateCell = '';
                    if (userInfo.RoleId === ROLE.GROK_ADMIN) {
                        if (student.CertificateId) {
                            previewCertificateButton = `<button id="${student.studentChallengeId}" class='backBtn_style' style="width: 150px">View Certificate</button>`;
                            certificateCell = `<td style="display: flex; justify-content: center; flex-direction: row;">${previewCertificateButton}</td>`;
                        } else {
                            previewCertificateButton = `<button id="${student.studentChallengeId}" class='backBtn_style'>Preview Certificate</button>`;
                            certificateButton = `<button id="${student.studentChallengeId}" class='backBtn_style'>Generate Certificate</button>`;
                            certificateCell = `<td style="display: flex; justify-content: space-around; flex-direction: row;">${previewCertificateButton} <span style="margin-left: 10px">${certificateButton}</span></td>`;
                        }
                    }
                    tableRows.push(`<tr>
                                        <td class='text-nowrap'>${student.name}</td> 
                                        <td>${student.email}</td> 
                                        ${student.Solution != null ? `<td><button id=${student.studentChallengeId} class='backBtn_style'>View Solution</button></td>` : `<td><button disabled class='disable_button_style'>View Solution</button></td>`}
                                        ${student.VideosUpload ? `<td><button id=${student.VideosUpload} class='backBtn_style'>Download Demo Video</button></td>` : `<td><button disabled class='disable_button_style'>Download Demo Video</button></td>`}
                                        ${certificateCell} 
                                    </tr>`);
                });
            });

            setTimeout(() => {
                StudentTable.current.innerHTML = tableRows.join('');
                document.getElementById('ChallengeTitle').innerText = title;
                if (role !== "Company") {
                    document.getElementById('ChallengeOrgName').innerText = orgName;
                }
            }, 10);
        }
    };

    const addEventListener = () => {
        document.addEventListener("click", handleEvent);
    };
    function handleEvent(event) {
        if (event.target.textContent === "View Solution" && event.target.className === "backBtn_style") {
            handleMyChallengesShow(event.target.id);
        }
        else if (event.target.textContent === "Download Demo Video" && event.target.className === "backBtn_style") {
            handleVideoDownloadStudentChallenge(event.target.id);
        }
        else if (event.target.textContent === "Preview Certificate" && event.target.className === "backBtn_style") {
            handleParticipationCertShow(event.target.id);
        }
        else if (event.target.textContent === "View Certificate" && event.target.className === "backBtn_style") {
            handleParticipationCertShow(event.target.id);
        }
        else if (event.target.textContent === "Generate Certificate" && event.target.className === "backBtn_style") {
            handleCertificateGenerate(event.target.id);
        }
    }
    // participant certificate view and generate
    let isRequestInProgress = false;
    const handleCertificateGenerate = (studentchallengeid) => {
        if (studentchallengeid && !isRequestInProgress) {
            isRequestInProgress = true;
            getapproval(studentchallengeid)
        }
    }

    const columns = [
        {
            name: "Title",
            width: "250px",
            selector: row => row.Title,
            sortable: true,
            cell: row => row.Title,
        },
        {
            name: "Industry Partner",
            width: "250px",
            selector: row => row.OrganizationId?.name,
            sortable: true,
            cell: row => row.OrganizationId?.name,
            omit: (role == "Company") ? true : (role == "Grok Admin") ? false : (role == "College") ? false : true
        },
        {
            name: "Notification Status", // Notification Status
            width: "180px",
            selector: row => row.NotificationStatus == 1 ? "Published" : "UnPublished",
            sortable: true,
            cell: row => row.NotificationStatus == 1 ? "Published" : "UnPublished",
            omit: (role == "Company") ? true : (role == "Grok Admin") ? false : true,
            conditionalCellStyles: [
                {
                    when: row => row.NotificationStatus == 1,
                    style: {
                        color: 'green',
                    },
                },
                {
                    when: row => row.NotificationStatus == 0,
                    style: {
                        color: 'red',
                    },
                },
            ],
        },
        {
            name: "Use Case Status", // Use Case Status
            width: "150px",
            selector: row => row.ChallengeStatus == 1 ? "Open" : "Concluded",
            sortable: true,
            cell: row => row.ChallengeStatus == 1 ? "Open" : "Concluded",
            //   omit: (role == "Company") ? true : (role == "Grok Admin") ? false : true,
            conditionalCellStyles: [
                {
                    when: row => row.ChallengeStatus == 1,
                    style: {
                        color: 'green',
                    },
                },
                {
                    when: row => row.ChallengeStatus == 0,
                    style: {
                        color: 'red',
                    },
                },
            ],
        },
        {
            name: "Closing Date",
            width: "180px",
            selector: row => moment(row.ClosingDate).format("DD/MM/YYYY"),
            sortable: true,
            cell: row => moment(row.ClosingDate).format("DD/MM/YYYY")
        },
        {
            name: "No. of Colleges ",
            width: "180px",
            selector: row => row.recordOrganizationCount,
            sortable: true,
            cell: row => row.recordOrganizationCount,
            omit: (role !== "Company") ? true : false
        },
        {
            name: "No. of  Particpants ",
            width: "180px",
            selector: row => row.studentCount,
            sortable: true,
            cell: row => row.studentCount,
            omit: (role !== "Company") ? true : false
        },
        {
            name: "Participation Details",
            width: "150px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Participant Details" onClick={() => handleShowParticipants(row._id, row.Title, row.OrganizationId.name)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role == "Student") ? true : false
        }, {
            name: "Created By",
            width: "230px",
            alignItems: "center",
            selector: row => row.CreatedBy?.name != null ? row.CreatedBy?.name : "NA",
            sortable: true,
            cell: row => row.CreatedBy?.name != null ? row.CreatedBy?.name : "NA",
            omit: (role !== 'Grok Admin') ? true : false
        },
        {
            name: "Updated By",
            width: "230px",
            alignItems: "center",
            selector: row => row.UpdatedBy?.name != null ? row.UpdatedBy?.name : "NA",
            sortable: true,
            cell: row => row.UpdatedBy?.name != null ? row.UpdatedBy?.name : "NA",
            omit: (role !== 'Grok Admin') ? true : false
        },
        {
            name: "Actions",
            width: "230px",
            cell: (row) => (<>
                {(role == "Grok Admin" || role == "Company") && <button className="btn btn-link ms-1" title="Edit" onClick={() => handleButtonEdit(row._id, row.OrganizationId.id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>}
                {(role == "Grok Admin" || role == "Company") && <button className="btn btn-link ms-1" title="Delete" onClick={() => handleButtonDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>}
                {(role == "Grok Admin" || role == "Company" || role == "College") && <button className="btn btn-link" title="Description" onClick={() => handleShow(row.Title, row.ChallengeBrief)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"></path></svg></span></button>}
                {<button className="btn btn-link" title="Download Use case Pdf" onClick={() => handleDownload(row.PdfUpload)} disabled={!row.PdfUpload ? true : false}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path></svg></span></button>}
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const tableData = {
        columns,
        data,
        allowOverflow: true
    };

    const addChallenges = () => {
        navigate('/industryusecasedetails', { state: { challengeid: null } });
    }

    const handleButtonEdit = (id, orgId) => {
        navigate('/industryusecasedetails', { state: { challengeid: id, organizationid: orgId } });
    }

    const BackBtn = () => {
        navigate('/home');
    }

    const getChallenges = async () => {
        setLoading(true);
        if (userInfo.RoleId == ROLE.GROK_ADMIN) { // Grok Admin
            let challengePayload = {
                RoleId: ROLE.GROK_ADMIN
            }
            var challengeResponse = await GetChallenges(challengePayload);
            setFilteredData(challengeResponse.data);
        }
        else if (userInfo.RoleId == ROLE.COMPANY) { // Company
            let challengePayload = {
                RoleId: ROLE.COMPANY,
                OrganizationId: userInfo.OrganizationId
            }
            var challengeResponse = await GetChallenges(challengePayload);
            setData(challengeResponse.data);
        }
        else if (userInfo.RoleId == ROLE.COLLEGE) { // college
            let challengePayload = {
                RoleId: "646b6ab024905f7d33a65cdc",
                OrganizationId: userInfo.OrganizationId
            }
            var challengeResponse = await GetChallenges(challengePayload);
            setData(challengeResponse.data);
        }
        else {
        }
        // setData(challengeResponse.data);
        setLoading(false);
    }

    const handleButtonDelete = async (id) => {
        ConfirmAlert("You want to Delete this Industry use case!", 'Are you sure?', 'warning', 'Yes, delete it!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await DeleteChallenge(id);
                    if (response) {
                        TimerAlert("success", "Industry use case Deleted Successfully", "success");
                        getChallenges();
                    }
                }
            }
        )
    }

    // Challenge Participate certificate approval 
    const getapproval = async (studentChallengeID) => {
        setLoading(true);
        let approvalpayload = {
            StudentChallengeId: studentChallengeID,
            IsWinner: false
        }
        var ApprovalResponse = await GetApproval(approvalpayload);
        if (ApprovalResponse.status) {
            InforAlert("Success", 'Successfully certificate generated for this student', 'success', 'OK')
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowParticipants(false);
                }
            });
        }
        else{
            InforAlert("warning", ApprovalResponse.response.data.error, 'warning', 'OK')
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowParticipants(false);
                }
            });
        }
        setLoading(false);
        isRequestInProgress = false
    }

    const getRoles = () => {
        if (userInfo.RoleId == ROLE.GROK_ADMIN) {    //Grok Admin
            setRole("Grok Admin");
        }
        else if (userInfo.RoleId == ROLE.STUDENT) {    //Student
            setRole("Student");
        }
        else if (userInfo.RoleId == ROLE.COMPANY) {    //Company
            setRole("Company");
        }
        else if (userInfo.RoleId == ROLE.COLLEGE) {    //College
            setRole("College");
        }
    }

    const addRefresh = () => {
        navigate('/home', { state: { challengeid: null } });
    }

    const handleNotificationFilter = () => {
        if (filterRef.current.value == 1) {
            let filterdChallenges = filteredData.filter((item) => item.NotificationStatus == true);
            setData(filterdChallenges);
        }
        else if (filterRef.current.value == 2) {
            let filterdChallenges = filteredData.filter((item) => item.NotificationStatus == false);
            setData(filterdChallenges);
        }
        else {
            setData([]);
        }
    }

    useEffect(() => {
        document.removeEventListener("click", handleEvent);
        getRoles();
        getChallenges();
        document.querySelectorAll(".navbar-nav .nav-item a")[2].classList.add("active");
        addEventListener();
        return () => {
            document.removeEventListener("click", handleEvent);
        };
    }, [])

    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Industry UseCases</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Industry usecase'>
                                    <span>
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M439 32v165h18V32h-18zm-18 12.99L327.6 80l93.4 35V44.99zM165.9 103c-5 0-10.2 2.3-15.3 7-6.2 5.8-11.5 15.1-13.8 26.3-2.3 11.3-1 22 2.5 29.7 3.5 7.8 8.6 12.3 14.6 13.5 6 1.3 12.4-.9 18.7-6.6 6.1-5.8 11.5-15.1 13.8-26.4 2.2-11.3.9-22-2.5-29.7-3.5-7.8-8.6-12.2-14.6-13.5-1.1-.2-2.3-.3-3.4-.3zm-38.4 78.5c-3.4 1.2-6.9 2.5-10.7 4.1-24.85 15.7-42.2 31.2-59.84 55.7-11.19 15.5-11.74 42-12.58 61.5l20.8 9.2c.87-27.8.36-39.3 13.27-55.3 9.83-12.2 19.33-25 37.55-28.9 1.6 28.9-2.6 73.7-14 119.6 20.5 2.8 37.6-.7 57-6.3 50.7-25.3 74.1-3.8 109.3 45.7l20.5-32.1c-24.6-28.9-48.5-75.1-117.2-57.3 5-27.3 5.6-45.4 8.6-72.6.6-12 .8-23.9 1.1-35.7-8.9 6.8-19.9 10.4-31 8.1-9.5-2-17.3-7.9-22.8-15.7zm144.2 7.3c-18.2 17.8-22.2 31-50.2 38.4l-22.5-24c-.4 12.8-.8 25.9-1.9 39.2 9.5 8.7 19.2 15.7 22.7 14.6 31.3-9.4 40.3-20.3 61.4-41.9l-9.5-26.3zM409 215v96h-96v96h-96v78.1c102.3.2 167.8 1.1 270 1.8V215h-78zM140.7 363.9c-13.6 2.5-27.8 3.3-43.44.9-10.89 37.5-26.76 74.3-48.51 102.5l38.63 15.3c27.02-37.9 36.82-70.6 53.32-118.7z"></path></svg>
                                    </span>
                                </Button>
                                <h2 className="page-title"> Industry UseCases</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1 my-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0">Challenges list</div> */}
                                        </div>
                                    </Col>
                                    {role === "Grok Admin" && <Col lg={3} sm={6} className='col-12 col-md-auto ms-auto'>
                                        <Form.Select ref={filterRef} as="select" onChange={handleNotificationFilter}>
                                            <option value={''}>Notification Status</option>
                                            <option value={1}>Published</option>
                                            <option value={2}>UnPublished</option>
                                        </Form.Select>
                                    </Col>}
                                    {!((role == 'Student') || (role == 'College')) && <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="backBtn_style" onClick={() => addChallenges()} >
                                            Add UseCase
                                        </button>
                                    </Col>}
                                </Row>
                            </div>
                            <div>
                                <div className='taablist'>
                                    <DataTableExtensions {...tableData}>
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            fixedHeader
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationPerPage={20}
                                            noDataComponent={(role === 'Grok Admin') ?
                                                (<span className='my-4'>Please select Notification status</span>) :
                                                (<span className='my-2'>There are no records to display</span>)}
                                            paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                            rowCount={25}
                                            rowsPerPage={20}
                                        />
                                    </DataTableExtensions>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            <Modal.Header closeButton>
                                <Modal.Title><b>Industry Use Case Description</b> </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <Row className="align-items-center">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <div id='Title'></div>
                                                </Form.Label>
                                                <div className="col">
                                                    <div className='small' id='Description'></div>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>

                    <div>
                        <Modal show={showParticipants} onHide={handleCloseParticipants} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            {loading ? <GrokLoading className="loading_src_style" /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title><b>Participants Details</b> </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='challenge_detail_style mb-3 d-flex bold'>
                                    <h5 id='ChallengeTitle' className='mx-2 mt-1'></h5>{role !== "Company" && `-`}
                                    {role !== "Company" && <h5 id='ChallengeOrgName' className='mx-2 mt-1'></h5>}
                                </div>
                                <div className='mt-2'>
                                    <Table striped bordered hover responsive>
                                        <thead className='fw-boldc'>
                                            <tr className='title'>
                                                <th>Associate College</th>
                                                <th>SParticipants</th>
                                                <th>Email</th>
                                                <th>Project Report</th>
                                                <th>Video</th>
                                                {(role === "Grok Admin") && <th colSpan={2} style={{ textAlign: "center" }}>Certificate</th>}
                                            </tr>
                                        </thead>
                                        <tbody ref={StudentTable}></tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>

                    <div>
                        <Modal show={myChallengeShow} onHide={handleMyChallengesClose} size="lg" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            {loading ? <GrokLoading /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title><b>Project Report</b> </Modal.Title>
                                <div className='mx-5'>
                                    <button className="downloadBtn" x={30} onClick={toPDF}>
                                        <span className='mx-1'><svg className='mb-1' stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z" fill="currentColor"></path><path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor"></path></svg>&nbsp;
                                            Download
                                        </span>
                                    </button>
                                </div>
                            </Modal.Header>
                            <div ref={targetRef}>
                                <Modal.Body>
                                    <div>
                                        <Row className='report_style p-2'>
                                            <Col lg={12} className='text-center mb-3 text-uppercase'> <h4><b>{challengeName}</b></h4></Col>
                                            <Row className="mb-1 mt-2">
                                                <Col className='col'> <h5>Student Name: <b>{name}</b></h5></Col>
                                                <Col className='col-md-auto'> <h5>Associate College Name: <b>{collegeName}</b></h5></Col>
                                            </Row>
                                            <Row className="mb-1">
                                                <Col className='col'> <h5>Year/Semester <b>{year}/{semester}</b></h5></Col>
                                                <Col className='col-md-auto'> <h5>Branch: <b>{branch}</b></h5></Col>
                                            </Row>
                                            <Row className="mb-1">
                                                <Col className='col'> <h5>Registered On: <b>{registeredDate}</b></h5></Col>
                                                <Col className='col-md-auto'> <h5>Submitted On: <b>{submittedDate}</b></h5></Col>
                                            </Row>
                                        </Row>
                                        <Row className='p-3'>
                                            <Col lg={12} className="mb-2">
                                                <div className="studhead mb-2 pb-2">
                                                    <span>Submitted Details</span>
                                                </div>
                                                <Row className="m-2">
                                                    <Col xs={6}> <p>Available Components</p> </Col>
                                                    <Col xs={6}> <p> <b>{availableComponents} </b> </p> </Col>

                                                    <Col xs={6}> <p>Additional Components</p> </Col>
                                                    <Col xs={6}> <p> <b>{additionalComponents}</b> </p> </Col>

                                                    <Col xs={6}> <p>Solution</p> </Col>
                                                    <Col xs={6}> <p> <b>{solution}</b> </p> </Col>

                                                    <Col xs={6}> <p>Project Brief</p> </Col>
                                                    <div className='ms-4'> <p> <b>{projectBrief}</b> </p></div>

                                                    <Col xs={6}> <p>Feedback</p> </Col>
                                                    <div className='ms-4'> <p> <b>{feedBack}</b> </p></div>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {(circuitDiagram !== 'null') && <Row>
                                            <Col lg={12} className="mb-4">
                                                <div className="fw-bold studhead pb-2 m-2">
                                                    <span>Circuit Diagram</span>
                                                </div>
                                                <Row className="mb-1">
                                                    <div>
                                                        <img className="img-w-h img-fluid" alt='circuit diagram' src={circuitDiagram} />
                                                    </div>
                                                </Row>
                                            </Col>
                                        </Row>}
                                        {(pythonCode !== 'null') && <Row>
                                            <Col lg={12} className="mb-4 p-2">
                                                <div className="fw-bold studhead mb-3 pb-2">
                                                    <span>Python Program</span>
                                                </div>
                                                <Row className="mb-1">
                                                    <div>
                                                        <img className="img-w-h img-fluid" alt='python code' src={pythonCode} />
                                                    </div>
                                                </Row>
                                            </Col>
                                        </Row>}
                                    </div>
                                </Modal.Body>
                            </div>
                        </Modal>
                    </div>
                    <div>
                        <Modal show={participationcertShow} onHide={handleParticipationCertClose} size="lg" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            {loading ? <GrokLoading /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title><b>Participation Certificate</b> </Modal.Title>
                                <div className='mx-5'>
                                    <button className="downloadBtn" x={30} onClick={toPDF} hidden={certificateId === undefined}>
                                        <span><svg className='mb-1' stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z" fill="currentColor"></path><path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor"></path></svg>&nbsp;
                                            Download
                                        </span>
                                    </button>
                                </div>
                            </Modal.Header>
                            <div ref={targetRef}>
                                <Modal.Body>
                                    <div>
                                        <div className='my-3'>
                                            <div className="container gcc-certificate-container">
                                                <div className='border-line1'>
                                                    <div className='border-line2'>
                                                        <div className="gcc-certificate-border col-md-12">
                                                            <div className="pm-certificate-body">
                                                                <img src={require("../../images/certificate_img/header_logo.png")} className="bgs-logo" alt="logo" title="Profile" />

                                                                <div className="col-md-2 text-center">
                                                                    <img src={require("../../images/certificate_img/icon01-bg.png")} className="img-fluid greet-logo" alt="logo" title="Profile" />
                                                                </div>
                                                                <div className="row pm-certificate-header">
                                                                    <div className="col-md-2"></div>
                                                                    <div className="gcc-certificate-title cursive col-md-12 text-center">
                                                                        <img src={require("../../images/certificate_img/pc_certificate.png")} className="img-fluid pc_cert_logo" alt="logo" title="participate_certificate" />
                                                                    </div>
                                                                </div>

                                                                <div className="pm-certificate-block row">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="pm-certificate-name margin-0 col-md-10 text-center mt-3">
                                                                                <img src={require("../../images/certificate_img/pc-cert-font.png")} className="img-fluid pc_cert_font" alt="logo" title="participate_certificate" />
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-md-2"></div>
                                                                            <div className="pm-certificate-name margin-0 col-md-8 text-center">
                                                                                <span className=" padding-0 my-3 block cursive text-bold">This Certificate is awarded to</span>
                                                                            </div>
                                                                            <div className="col-md-2"></div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="col-md-2 gcc-course-title">Mr./Ms. </div>
                                                                            <div className="pm-course-title underline_gcc col-md-8 text-center">
                                                                                <span className="pm-credits-text block sans"><span className="arima bold" >{CertificateData.Student?.Name}</span></span>
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="row mt-3">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="col-md-2 gcc-course-title">from </div>
                                                                            <div className="pm-course-title underline_gcc col-md-8 text-center mt-2">
                                                                                <span className=" block bold arima">{CertificateData.College?.Name}</span>
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-md-2"></div>
                                                                            <div className="pm-course-title col-md-8 text-center">
                                                                                <span className="block cursive">for successfully presenting a solution</span>
                                                                            </div>
                                                                            <div className="col-md-2"></div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <div className="row mt-2">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="pm-course-title underline_gcc col-md-10 text-center">
                                                                                <span className=" block bold arima">{CertificateData.Challenge?.Title}</span>
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>

                                                                        <div className="row">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="pm-course-title col-md-10 text-center">
                                                                                <span className=" block cursive">While completing the Industry Use case Challenge</span>
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>

                                                                        <div className="row mt-2">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="pm-course-title underline_gcc col-md-8 text-center">
                                                                                <span className=" block bold arima">{CertificateData.Challenge?.Organization?.Name}</span>
                                                                            </div>
                                                                            <div className="col-md-3 gcc-course-title">Posed by us. </div>
                                                                        </div>

                                                                        <div className="row">
                                                                            <div className="col-md-1"></div>
                                                                            <div className="pm-course-title col-md-10 text-center">
                                                                                <span className=" block cursive">We wish him/her all the success in his/her future endeavours.</span>
                                                                            </div>
                                                                            <div className="col-md-1"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12 mt-2">
                                                                    <div className="row arima">
                                                                        <div className="col-md-4 mt-3 pm-certified text-center">
                                                                            <span><img src={CertificateData.Challenge?.Organization?.Logo ? CertificateData.Challenge?.Organization?.Logo : require("../../images/empty_logo.png")} width={100} height={100} className="img-fluid" alt="logo" title="Profile" /></span>
                                                                            <span className="block text-secondary mt-2 foot_text">Industry partner</span>
                                                                        </div>
                                                                        <div className="col-md-4 pm-certified text-center mt-3">
                                                                            <span><img src={require("../../images/sign.png")} width={50} height={50} className="img-fluid" alt="logo" title="Profile" /></span>
                                                                            <span className="bold block">Anagaha Komawar</span>
                                                                            <span className="text-secondary block foot_text">Co-founder <br />Grok Learning Pvt Ltd.</span>
                                                                            <span className="text-secondary block"></span>
                                                                        </div>
                                                                        <div className="col-md-4 pm-certified text-center mt-5">
                                                                            <span><img src={require("../../images/grok pvt ltd logo.png")} className="img-fluid cert-logo" alt="logo" title="Profile" /></span>
                                                                            <span className="block text-primary foot_text">www.grovator.com</span>
                                                                            <span className="block text-secondary foot_text ">Date of Issue: </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='row text-center mt-4'>
                                                                    <h5 className='certified-no arima mx-2 text-bold'>Certificate No : <b>{CertificateData.CertificateId}</b> </h5> <h5 className='certificate_sty'></h5>
                                                                </div>
                                                                <div className="col-md-2 text-center">
                                                                    <img src={require("../../images/certificate_img/icon02-bg.png")} className="img-fluid greet-logo1" alt="logo" title="Profile" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </div>
                        </Modal>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default Challenges; 